import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MeetingService } from 'src/app/services/meeting.service';

@Component({
  standalone: false,
  selector: 'app-cancel-meetingroom-booking',
  templateUrl: './cancel-meetingroom-booking.component.html',
  styleUrls: ['./cancel-meetingroom-booking.component.scss'],
})
export class CancelMeetingroomBooking implements OnInit {
  @Input() id: string;
  @Input() meetingRoomId: string;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private meetingService: MeetingService,
  ) {
  }

  ngOnInit(): void { }

  cancelBooking() {
    const payload = {
      bookingId: this.meetingRoomId
    };
    this.meetingService.cancelBlockedMeetingRoom(this.meetingRoomId).subscribe((res) => {
      this.modal.close();
      // this.modal.dismiss();
      location.reload();
      setTimeout(() => {
        location.reload();
      }, 10000);
    });
  }
}
